var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcellenceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 108,
    rx: 10,
    fill: "#CF375D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.7578 26.6038C51.0879 26.0373 51.5608 25.5673 52.1293 25.2406C52.6978 24.9139 53.3421 24.7419 53.9978 24.7419C54.6535 24.7419 55.2977 24.9139 55.8662 25.2406C56.4347 25.5673 56.9076 26.0373 57.2378 26.6038L65.6228 40.9978L81.9068 44.5258C82.5473 44.665 83.1402 44.9697 83.6262 45.4094C84.1123 45.8492 84.4747 46.4087 84.6771 47.0321C84.8796 47.6556 84.9151 48.3212 84.7801 48.9626C84.6451 49.604 84.3443 50.1989 83.9078 50.6878L72.8078 63.1108L74.4878 79.6859C74.554 80.3385 74.4479 80.9972 74.18 81.596C73.9122 82.1948 73.4919 82.7129 72.9611 83.0985C72.4304 83.4841 71.8078 83.7237 71.1555 83.7935C70.5032 83.8632 69.844 83.7606 69.2438 83.4959L53.9978 76.7758L38.7518 83.4959C38.1515 83.7606 37.4923 83.8632 36.84 83.7935C36.1877 83.7237 35.5651 83.4841 35.0344 83.0985C34.5036 82.7129 34.0833 82.1948 33.8155 81.596C33.5476 80.9972 33.4415 80.3385 33.5078 79.6859L35.1878 63.1108L24.0878 50.6908C23.6504 50.2019 23.349 49.6068 23.2136 48.965C23.0782 48.3232 23.1135 47.657 23.316 47.0331C23.5185 46.4092 23.8811 45.8493 24.3677 45.4093C24.8542 44.9694 25.4477 44.6647 26.0888 44.5258L42.3728 40.9978L50.7578 26.6038Z",
    fill: "#ECB32C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcellenceIcon);
export default __webpack_public_path__ + "static/media/excellence-icon.2e2da97e830bc24b32c8ff1291c7ea9b.svg";
export { ForwardRef as ReactComponent };